import { environment } from "../../environments/environment";

export class Constants {
  public static readonly BASE_API_URL = `${environment.apiUrl}`;
  public static readonly API_SECRET = `${environment.apiSecret}`;

  public static readonly EMAIL_VALIDATOR_REGEX =
    "^\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,4})+$";
  public static numberRegexp = /^[0-9-/+]*$/;

  public static readonly DRAFT = "DRAFT";
  public static readonly PUBLISHED = "PUBLISHED";
  public static readonly UNPUBLISHED = "UNPUBLISHED";

  public static readonly HEADING = "Heading";
  public static readonly TEXTBOX = "TextBox";
  public static readonly TEXTAREA = "TextArea";
  public static readonly SELECTBOX = "SelectBox";
  public static readonly RADIO = "Radio";
  public static readonly DATESELECTOR = "DateSelector";
  public static readonly SEPARATOR = "Separator";
  public static readonly PARAGRAPH = "Paragraph";
  public static readonly FORMULAS = "Formulas";
  public static readonly PAYMENT = "Payment";
  public static readonly TABLE = "Table";
  public static readonly ADDRESS = "Address";
  public static readonly MULTIPLECHOICES = "MultipleChoices";
  public static readonly USERINFOFIELDS = "UserInfoFields";
  public static readonly IMAGE = "Image";

  public static readonly CLIENTSECRET = "%$K8WpJ8TDEm8Kom";

  public static readonly DYNAMIC_ROW_IN_TABLE = 'DYNAMIC ROW IN A TABLE';
  public static readonly IS_EQUAL_TO = 'IS EQUAL TO';
  public static readonly IS_NOT_EQUAL_TO = 'IS NOT EQUAL TO';
  public static readonly COUNTS = 'COUNTS';
  public static readonly CHANGES = 'CHANGES';
  public static readonly SET_ROW_COUNT = 'SET ROW COUNT';
  public static readonly CONTAINS = 'CONTAINS';

  
  public static readonly EMAIL = "Email";
  public static readonly FORMBGCOLOR = "#eeeeee";

  public static readonly EXTERNAL_PAYMENT = 'EXTERNAL';
  public static readonly INTERNAL_PAYMENT = 'INTERNAL';
}
